import { Group, Select } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { SymptomSeverities } from 'models/generic';
import { displayFormError } from 'utils/validation';
import { AccordionWithSwitch } from './AccordionWithSwitch';

export const SymptomSeverityFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();
  const dataField = 'data.heartRhythmMeasurement.symptomSeverityCondition';

  return (
    <AccordionWithSwitch title={t('patients_info_severity')} dataField={dataField}>
      <Group justify={'flex-start'}>
        <Select
          label={t('severity_label')}
          {...getInputProps(`${dataField}.symptomSeverity`)}
          data={Object.values(SymptomSeverities)
            .filter((value) => value !== SymptomSeverities.none)
            .map((value) => ({
              value,
              label: t(`symptom_severity_${value}`),
            }))}
          disabled={values.formDisabled}
          error={displayFormError({
            errors,
            dataField: `${dataField}.symptomSeverity`,
            label: t('empty_value_select'),
          })}
        />
      </Group>
    </AccordionWithSwitch>
  );
};
